
<mat-card 
  *ngIf="designerLogin==='userPassword'" 
  [ngClass]="{
    'col-width-large': !(isSmallerScreenObs | async),
    'full-stretch':isSmallerScreenObs | async
  }"
>
    
    <mat-card-header #cardHeader class="border-primary-bottom padding-standard ">
        <mat-card-title class="mat-headline-4 margin-none">{{'ss-auth.login' | translate}}</mat-card-title>
    </mat-card-header>
    
    <mat-card-content fixedScroll [otherElements]="[header,footer]" class="padding-none">

        <ss-dynamic-form 
          class="padding-standard display-block" 
          [autoFocusFirstControl]="true" 
          [controls]="controls" 
          (formSubmit)="formSubmit($event)"
          [submitButton]="submitBtn._elementRef?.nativeElement"
        >

        </ss-dynamic-form>
          
    </mat-card-content>

    <mat-card-footer #footer class="responsive-actions padding-standard border-gray-top flex-row-reverse">
      
      <button #submitBtn type="submit"  color="primary" mat-raised-button>
        {{ "ss-auth.sign-in" | translate }}
      </button>

    </mat-card-footer>

    
</mat-card>